import { fromJS } from 'immutable';
import {
  VENDOR_FETCH_REQUESTED,
  VENDOR_FETCH_SUCCEEDED,
  VENDOR_FETCH_FAILED
} from '../../actions';
import { requestedReducer, succeededReducer, failedReducer } from '../request';

const initialState = {
  request: {
    requested: false,
    succeeded: false,
    failed: false
  },
  signs: [],
  displayName: '',
  logo: {
    url: ''
  },
  video: {
    url: ''
  }
};

function vendorRequested(state) {
  let newState = fromJS(state);
  const request = fromJS(requestedReducer(newState.get('request').toJS()));
  newState = newState.merge({ request });
  return newState.toJS();
}

function vendorSucceeded(state, action) {
  let newState = fromJS(state);

  const request = fromJS(succeededReducer(newState.get('request').toJS()));
  newState = newState.merge({ request });

  let logo = newState.get('logo');

  if (action.data.length > 0) {
    const { fields } = action.data[0];
    const signs = fromJS(
      fields.signs.map(sign => ({
        id: sign.fields.id,
        name: sign.fields.name
      }))
    );
    const { displayName } = fields;

    logo = logo.merge({
      url: `http://${fields.logo.fields.file.url.slice(2)}`
    });

    newState = newState.merge({ signs, displayName, logo });
  }

  return newState.toJS();
}

function vendorFailed(state) {
  let newState = fromJS(state);
  const request = fromJS(failedReducer(newState.get('request').toJS()));
  newState = newState.merge({ request });
  return newState.toJS();
}

export default function(state, action) {
  if (typeof state === 'undefined') {
    return initialState;
  }

  switch (action.type) {
    case VENDOR_FETCH_REQUESTED:
      return vendorRequested(state, action);
    case VENDOR_FETCH_SUCCEEDED:
      return vendorSucceeded(state, action);
    case VENDOR_FETCH_FAILED:
      return vendorFailed(state, action);
    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./src/reducers/vendor/index.js